import {ProgrammingRecord,Stage} from './model';
export const readinessSteps=['REVIEW','PROGRAMMING','TESTING','READY'] as const;
export type ReadinessStep=typeof readinessSteps[number];
export const nextStep:Partial<Record<Stage,ReadinessStep>>={REVIEW:'PROGRAMMING',PROGRAMMING:'TESTING',TESTING:'READY'};
export const actionLabel:Partial<Record<Stage,string>>={REVIEW:'Complete Review → Start Programming',PROGRAMMING:'Programming Complete → Start Testing',TESTING:'Testing Passed → Mark Ready'};
export const present=(v:unknown):boolean=>v!==undefined&&v!==null&&(typeof v==='string'?v.trim()!=='':Array.isArray(v)?v.some(present):typeof v==='object'?Object.keys(v).length>0:true);
export function requirements(record:ProgrammingRecord,fallbackKeys:readonly string[]) {
 const keys=record.required_keys||[...fallbackKeys];const snapshot=record.revisions?.find(r=>r.revision===record.revision)?.snapshot;
 const known=!!snapshot?.fields;const fields=snapshot?.fields||{};
 const missing=keys.filter(k=>!present(fields[k]));
 return {keys,fields,known,missing,manual:record.missing.filter(k=>!keys.includes(k)),supplied:keys.length-missing.length};
}
export function completedStep(record:ProgrammingRecord,step:ReadinessStep) {
 const current=readinessSteps.indexOf(record.stage as ReadinessStep),index=readinessSteps.indexOf(step);
 if(current<0||index>=current||record.reviewed_revision!==record.revision)return false;
 return step==='TESTING'?record.tested_revision===record.revision:true;
}
export function evidenceFor(record:ProgrammingRecord,step:ReadinessStep) {
 const target=nextStep[step];
 return record.audit?.find(a=>a.action==='STAGE'&&a.detail.revision===record.revision&&a.detail.to===target&&a.detail.from===step);
}
export function advanceProblem(record:ProgrammingRecord,evidence:string,confirmed:boolean,manual:string[],fallbackKeys:readonly string[]) {
 if(!nextStep[record.stage])return 'No next stage is available.';
 if(!evidence.trim())return record.stage==='TESTING'?'Record actual testing evidence.':'Record '+(record.stage==='REVIEW'?'review notes.':'what was programmed.');
 if((record.stage==='PROGRAMMING'||record.stage==='TESTING')&&record.reviewed_revision!==record.revision)return 'The current blueprint revision must be reviewed first. Reload and review current requirements.';
 if(record.stage==='TESTING'){
  const r=requirements(record,fallbackKeys);
  if(!r.known)return 'Current client requirements are unavailable. Reload before marking Ready.';
  if(r.missing.length||manual.length)return 'Resolve the outstanding information before marking Ready.';
  if(!confirmed)return 'Confirm that actual booth testing passed.';
 }
 return '';
}
